import { IconPropsType } from '..';

export const OperatorsIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4341_10011)">
      <path
        d="M9.1 0.700012C9.4864 0.700012 9.8 1.01361 9.8 1.40001V4.20001C9.8 4.58641 9.4864 4.90001 9.1 4.90001H7.7V6.30001H10.5C10.8864 6.30001 11.2 6.61361 11.2 7.00001V9.10001H12.6C12.9864 9.10001 13.3 9.41361 13.3 9.80001V12.6C13.3 12.9864 12.9864 13.3 12.6 13.3H8.4C8.0136 13.3 7.7 12.9864 7.7 12.6V9.80001C7.7 9.41361 8.0136 9.10001 8.4 9.10001H9.8V7.70001H4.2V9.10001H5.6C5.9864 9.10001 6.3 9.41361 6.3 9.80001V12.6C6.3 12.9864 5.9864 13.3 5.6 13.3H1.4C1.0136 13.3 0.699997 12.9864 0.699997 12.6V9.80001C0.699997 9.41361 1.0136 9.10001 1.4 9.10001H2.8V7.00001C2.8 6.61361 3.1136 6.30001 3.5 6.30001H6.3V4.90001H4.9C4.5136 4.90001 4.2 4.58641 4.2 4.20001V1.40001C4.2 1.01361 4.5136 0.700012 4.9 0.700012H9.1ZM4.9 10.5H2.1V11.9H4.9V10.5ZM11.9 10.5H9.1V11.9H11.9V10.5ZM8.4 2.10001H5.6V3.50001H8.4V2.10001Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4341_10011">
        <rect
          width="14"
          height="14"
          fill="currentColor"
        />
      </clipPath>
    </defs>
  </svg>
);
